/* eslint-disable react/prop-types */
import {
	Badge,
	Box,
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Typography
} from "@material-ui/core";
import lod_ from "lodash";
import React, { useEffect, useState } from "react";
import cockpitActions from "../../../redux/actions/cockpitActions";
import i18n from "i18next";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getIntentLabel } from "helpers/utilities";
import { getMesssageItemSelector } from "redux/selectors/cockpitSelectors";
import GetChannelImage from "helpers/GetChannelImage";
import { handleSpecialDisplayDate, formatDate } from "helpers/utilities";
import { api } from "redux/actions/api";
import { computeAgentName } from "helpers/conversationUtils";
import generalConstant from "../../../constants/general";

export const ModalAssignContact = ({ openModal, setOpenModal, payloadRes, convContact }) => {
	const [convs, setConvs] = useState([]);
	const [selectedItems, setSelectedItems] = useState([]);
	const { assistantConfig, selectedAssistantID } = useSelector(state => state);
	const { user } = useSelector(state => state.userStatus?.auth);

	const aConfig = useSelector(getMesssageItemSelector, shallowEqual);
	const intents = aConfig?.intents ?? [];
	const selectedConversationFID = payloadRes?.selectConversation?.header?.fID;

	const dispatch = useDispatch();

	useEffect(() => {
		if (openModal === true && !lod_.isEmpty(convContact)) {
			const sortedConvs = [...convContact].sort((a, b) => {
				const stateA = a?.header?.state || "";
				const stateB = b?.header?.state || "";
				const priorityA = stateA === "waiting" ? 0 : 1;
				const priorityB = stateB === "waiting" ? 0 : 1;

				if (priorityA !== priorityB) {
					return priorityA - priorityB;
				}

				if (stateA !== stateB) {
					return stateA.localeCompare(stateB);
				}

				const dateA =
					Number(a?.meta?.cockpit?.ts) || Date.parse(a?.meta?.cockpit?.datetime || "") || 0;
				const dateB =
					Number(b?.meta?.cockpit?.ts) || Date.parse(b?.meta?.cockpit?.datetime || "") || 0;

				return dateB - dateA;
			});

			setConvs(sortedConvs);
			setSelectedItems([]);
		}
	}, [openModal]);

	const handleToggleItem = index => {
		setSelectedItems(prevSelected => {
			if (prevSelected.includes(index)) {
				return prevSelected.filter(selectedIndex => selectedIndex !== index);
			} else {
				return [...prevSelected, index];
			}
		});
	};

	const displayTitleConv = conv => {
		if (!lod_.isEmpty(conv?.meta?.cockpit?.title)) {
			return getIntentLabel(conv.meta?.cockpit.title, intents);
		}

		return "";
	};

	const handleClose = () => {
		setOpenModal(false);
		setConvs([]);
		setSelectedItems([]);
	};

	const handleValidConvAssign = () => {
		let convSelected = selectedItems.map(i => convs[i]);

		let userSelected = !lod_.isEmpty(payloadRes?.redirectTo) ? payloadRes?.redirectTo : user;
		let to = {
			name: computeAgentName(userSelected),
			first: userSelected.name,
			last: userSelected.surname,
			email: userSelected._id
		};

		let data = {
			code: "assignManyConv",
			action: "assignManyConv",
			data: {
				header: {
					assistantID: selectedAssistantID
				},
				payload: {
					to,
					convs: convSelected
				}
			},
			userGroups: user.groups,
			source: generalConstant.APP_NAME,
			ts: Date.now()
		};

		dispatch(
			api({
				method: "POST",
				type: "cockpit/actionFrontCustom",
				url: `/api/v1/actionFront/custom`,
				data,
				onSuccess: () => {}
			})
		);

		if (!lod_.isEmpty(selectedConversationFID)) {
			if (!lod_.isEmpty(payloadRes?.redirectTo) && payloadRes?.redirectTo?.userID !== user.userID) {
				dispatch(
					cockpitActions.redirectConversationToUser(
						payloadRes.selectConversation,
						payloadRes?.redirectTo,
						true
					)
				);
			} else {
				dispatch(cockpitActions.assignConversation(payloadRes.selectConversation, true));
			}
		}

		setOpenModal(false);
		setConvs([]);
		setSelectedItems([]);
	};

	return (
		<Dialog
			open={openModal}
			onClose={handleClose}
			onClick={e => e.stopPropagation()}
			fullWidth
			maxWidth="md"
			aria-labelledby="form-dialog-title"
		>
			<DialogTitle id="form-dialog-title">{i18n.t("modal.resolvedTitleModal")}</DialogTitle>
			<DialogContent dividers>
				<Badge badgeContent={selectedItems.length} color="primary">
					<Typography style={{ fontSize: "20px", fontWeight: "bold", paddingBottom: "1%" }}>
						{i18n.t("modal.choiceConvAssignContact")}
					</Typography>
				</Badge>
				{!lod_.isEmpty(selectedConversationFID) && (
					<Box display="flex" width={1} mt={2}>
						<Typography>
							{i18n.t("COC.selectedOriginConversation")} - {selectedConversationFID}
						</Typography>
					</Box>
				)}
				{lod_.isEmpty(convs) ? (
					<Box display="flex" alignItems="center" width={1} justifyContent="center">
						<Typography>{i18n.t("COC.noElementConv")}</Typography>
					</Box>
				) : (
					<Box>
						<List>
							{convs.map((item, index) => (
								<Box key={item?.header?.fID ?? index} style={{ display: "flex" }}>
									<ListItem
										button
										disabled={item?.header?.state !== "waiting"}
										onClick={() => handleToggleItem(index)}
									>
										<Checkbox checked={selectedItems.includes(index)} color="primary" />
										<ListItemAvatar>
											<img
												src={GetChannelImage(
													assistantConfig?.channels,
													item.meta?.cockpit?.channelCode,
													item?.header?.channel?.toUpperCase()
												)}
												alt="Channel-logo"
												width="30"
												height="30"
												className="logo-channel"
											/>
										</ListItemAvatar>
										<ListItemText
											primary={displayTitleConv(item) + " " + `(${item?.meta?.cockpit?.contact})`}
											secondary={
												(assistantConfig?.cockpit?.datetime_format?.format
													? handleSpecialDisplayDate(
															item?.meta?.cockpit?.ts,
															assistantConfig?.cockpit?.datetime_format?.format,
															user?.language?.toLowerCase() || "fr"
														)
													: formatDate(item?.meta?.cockpit?.datetime)) +
												" | " +
												item?.header?.fID
											}
										/>
									</ListItem>
								</Box>
							))}
						</List>
					</Box>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={() => handleClose()} style={{ color: "red" }} color="secondary">
					{`${i18n.t("COC.Cancel")}`}
				</Button>

				<Button onClick={() => handleValidConvAssign()} color="primary">
					<Badge badgeContent={selectedItems.length} color="primary">
						{`${i18n.t("COC.Apply")}`}
					</Badge>
				</Button>
			</DialogActions>
		</Dialog>
	);
};
